import { parsePagingQuery } from "../../../handlers/filter";
import { publisherGroupMediaTypeToService } from "../../../models/publisher";
const sortToQueryParam = (sort) => {
    if (sort && sort.field && sort.direction) {
        return `&sortBy=${sort.field}%20${sort.direction}`;
    }
    return "";
};
/**
 * Converts filters and sort into URL query parameters.
 * Extracts publisher-specific filters from the filters.where array.
 * @param filters - Optional Filter object with where, fields, and paging properties
 * @param sort - Optional sort configuration (field and direction)
 * @returns Query string with all parameters, or empty string if none provided
 */
export const toQueryParams = (filters, sort) => {
    const params = [];
    const pagingParams = parsePagingQuery(filters?.paging);
    if (pagingParams) {
        params.push(pagingParams.substring(1));
    }
    const sortParams = sortToQueryParam(sort);
    if (sortParams) {
        params.push(sortParams.substring(1));
    }
    // Extract publisher-specific filters from the where clause
    if (filters?.where) {
        for (const filter of filters.where) {
            switch (filter.field) {
                case "statuses":
                    if (Array.isArray(filter.value)) {
                        params.push(`statuses=${filter.value.join(",")}`);
                    }
                    break;
                case "mediaTypes":
                    if (Array.isArray(filter.value)) {
                        const joined = filter.value
                            .map(publisherGroupMediaTypeToService)
                            .join(",");
                        if (joined) {
                            params.push(`mediaTypes=${joined}`);
                        }
                    }
                    break;
                case "search":
                    if (typeof filter.value === "string") {
                        params.push(`search=${encodeURIComponent(filter.value)}`);
                    }
                    break;
                case "excludePublishers":
                    if (filter.value === true) {
                        params.push(`excludePublishers=true`);
                    }
                    break;
            }
        }
    }
    return params.length ? `?${params.join("&")}` : "";
};
//# sourceMappingURL=query.js.map